import store from "@/store"
import { TokenData } from "@/store/types"

class RobloxConnect {
  protected initialized: RobloxConnect | null = null

  constructor(public width = 600, public height = 600) {
    if (this.initialized) {
      return this.initialized
    }
    this.initialized = this
  }

  waitForLocalStorageKey(key: string, timeout = 60000): Promise<string> {
    return new Promise((resolve, reject) => {
      const start = Date.now()
      const interval = setInterval(() => {
        const value = localStorage.getItem(key)
        if (value) {
          clearInterval(interval)
          resolve(value)
        } else if (Date.now() - start > timeout) {
          clearInterval(interval)
          reject(new Error("Timeout waiting for localStorage key"))
        }
      }, 100)
    })
  }

  async connectRoblox() {
    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screenX
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : window.screenY
    const winWidth = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width
    const winHeight = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height

    const systemZoom = winWidth / window.screen.availWidth
    const left = (winWidth - this.width) / 2 / systemZoom + dualScreenLeft
    const top = (winHeight - this.height) / 2 / systemZoom + dualScreenTop

    const connectWindow = window.open(
      `${process.env.VUE_APP_API_URL}/api/auth/login`,
      "name",
      `
          scrollbars=yes,
          width=${this.width / systemZoom}, 
          height=${this.height / systemZoom}, 
          top=${top}, 
          left=${left}
        `
    )
    connectWindow?.focus()

    if (connectWindow) {
      const access_token = await this.waitForLocalStorageKey("access_token")
      const refresh_token = await this.waitForLocalStorageKey("refresh_token")
      // const scope = await this.waitForLocalStorageKey("scope")

      const tokenData: TokenData = {
        access_token,
        refresh_token,
        // scope,
      }
      store.dispatch("auth/setTokenData", tokenData)
      connectWindow?.close()
    }
  }
}

export default new RobloxConnect()
